import React, { forwardRef } from "react";
import classNames from "classnames";
import IBuildrProps from "../../utilities/IBuildrProps";

export interface IRateProps extends IBuildrProps {
    children: any;
}

const RateBox = forwardRef(({ className, editorClassObj, cmsId, children }: IRateProps, ref: any) => {
    return (
        <div ref={ref} data-id={cmsId} className={classNames(className, editorClassObj)}>
            {children}
        </div>
    );
});

export default RateBox;